module.exports = __webpack_public_path__ + "img/img_charge_img1.11c27f92.png";